// Task priority levels, shared by the Todo page, the calendar and the
// dashboard widgets so a task looks the same everywhere.
//
// The emoji doubles as the colour key: 🟡 low, 🟠 medium, 🔴 high — matching
// the badge background/text colours below.

export const PRIORITIES = [
  {
    id: 'low',
    labelKey: 'todo.priorityLow',
    emoji: '🟡',
    color: 'bg-yellow-100 text-yellow-800 border-yellow-300',
    dot: 'bg-yellow-400'
  },
  {
    id: 'medium',
    labelKey: 'todo.priorityMedium',
    emoji: '🟠',
    color: 'bg-orange-100 text-orange-800 border-orange-300',
    dot: 'bg-orange-500'
  },
  {
    id: 'high',
    labelKey: 'todo.priorityHigh',
    emoji: '🔴',
    color: 'bg-red-100 text-red-800 border-red-300',
    dot: 'bg-red-500'
  }
];

const BY_ID = PRIORITIES.reduce((acc, p) => {
  acc[p.id] = p;
  return acc;
}, {});

export const getPriority = (id) => BY_ID[id] || null;

// Empty string for "no priority" so callers can render it unconditionally.
export const priorityEmoji = (id) => BY_ID[id]?.emoji || '';

// Sort rank: high first, no priority last. Used wherever tasks are ordered.
const RANK = { high: 0, medium: 1, low: 2 };
export const priorityRank = (id) => (id in RANK ? RANK[id] : 3);
